import { Lock } from 'lucide-react';
import { API_BASE } from '../lib/auth';

/**
 * Mostrato quando un endpoint pro risponde 402 (requirePaid → abbonamento mancante o
 * trial scaduto). Sostituisce il fuorviante "Errore caricamento … controlla la connessione"
 * con un messaggio chiaro + CTA verso il pricing. Diagnosi 2026-05-29: il 402 veniva
 * trattato come errore di rete generico.
 */
export function PaywallNotice({ resource = 'questa sezione' }: { resource?: string }) {
  return (
    <div
      role="alert"
      style={{
        border: '2px solid var(--line, #0f1410)',
        borderRadius: 14,
        background: 'var(--paper, #fff)',
        padding: '28px 24px',
        maxWidth: 560,
        margin: '8px 0',
        boxShadow: '4px 4px 0 var(--line, #0f1410)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        <Lock size={20} strokeWidth={2.2} style={{ color: 'var(--green-deep, #0b8a3e)' }} />
        <h2 style={{ margin: 0, fontFamily: 'var(--display)', fontSize: 20, fontWeight: 800 }}>
          Abbonamento richiesto
        </h2>
      </div>
      <p style={{ color: 'var(--mute, #555)', fontSize: 14, lineHeight: 1.55, margin: '0 0 18px' }}>
        Per usare {resource} serve un abbonamento DietAmenu Pro attivo. Se il tuo periodo di
        prova è scaduto, attiva un piano per continuare a gestire i tuoi clienti.
      </p>
      <a
        href={`${API_BASE}/pricing`}
        style={{
          display: 'inline-block',
          padding: '11px 20px',
          background: 'var(--green-deep, #0b8a3e)',
          color: '#fff',
          borderRadius: 10,
          fontWeight: 800,
          fontSize: 14,
          textDecoration: 'none',
        }}
      >
        Vedi i piani →
      </a>
    </div>
  );
}
